import { GenericError } from '@psyomics/ui-components';
import { useParams } from 'react-router-dom';

import { Survey as SurveyFeature } from '../../../features/survey/survey';

const Questionnaire = () => {
  const { id: invitePublicId } = useParams();
  if (!invitePublicId) {
    return <GenericError />;
  }
  return <SurveyFeature invitePublicId={invitePublicId} />;
};

export default Questionnaire;
